import React, { useState, useRef, useMemo, useEffect } from 'react';
import { Input, InputGroup, InputGroupText, Button } from 'reactstrap';
import { mdiClockOutline } from '@mdi/js';
import Icon from '@mdi/react';

import './TimePicker.scss';

export default function TimePicker({
  name,
  value,
  onChange,
  interval = 15,
  disabled,
  invalid,
  title,
  className = '',
  error = false,
  ...props
}) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);
  const inputRef = useRef(null);

  // Build Interval in minutes slots
  const timeOptions = useMemo(() => {
    const slots = [];
    for (let h = 0; h < 24; h += 1) {
      for (let m = 0; m < 60; m += interval) {
        const minute = String(m).padStart(2, '0');
        const val = `${String(h).padStart(2, '0')}:${minute}`;

        // Convert to 12hr display
        const hour12 = ((h + 11) % 12) + 1; // 0 -> 12, 13 -> 1
        const ampm = h < 12 ? 'AM' : 'PM';
        const label = `${hour12}:${minute} ${ampm}`;

        slots.push({
          label,
          value: val,
        });
      }
    }
    return slots;
  }, [interval]);

  useEffect(() => {
    const onDocClick = e => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  // disable native picker on icon clicks in Chrome/Edge
  useEffect(() => {
    const inp = inputRef.current;
    if (inp?.showPicker) inp.showPicker = () => {};
  }, []);

  return (
    <div className="timepicker-wrapper" ref={wrapperRef}>
      <InputGroup>
        <Input
          type="time"
          name={name}
          innerRef={inputRef}
          value={value || ''}
          onChange={e => onChange(e.target.value)}
          disabled={disabled}
          invalid={invalid}
          autoComplete="off"
          className={`${className}`}
          title={props.title}
          onClick={() => !disabled && setOpen(true)}
        />
        <InputGroupText
          className="timepicker-toggle"
          style={{
            marginRight: error ? '1.5rem' : '0',
          }}
        >
          <Button
            color="link"
            onClick={() => !disabled && setOpen(prev => !prev)}
            style={{ padding: 0 }}
            tabIndex={-1}
          >
            <Icon
              path={mdiClockOutline}
              size={0.75}
              style={{ cursor: disabled ? 'default' : 'pointer' }}
            />
          </Button>
        </InputGroupText>
      </InputGroup>

      {open && (
        <ul className="timepicker-dropdown">
          {timeOptions.map(opt => (
            <li key={opt.value} className="timepicker-item">
              <button
                type="button"
                className="timepicker-btn"
                onMouseDown={e => {
                  e.preventDefault();
                  onChange(opt.value);
                  setOpen(false);
                }}
                tabIndex={-1}
              >
                {opt.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
